import React, {Component, PropTypes} from 'react'
import {connect} from "react-redux"
import {setClientSubModule, setOpened, setOpenedSubmenu, fetchClientOptionsDict,
    fetchOfficeData, saveClinetNote, getClientNote, setNotification, deleteClientNote, fetchRelationClient} from 'state/actions'
import styles from './clientProfile.scss'
import KeyValue from '../KeyValue'
import Uploader from '../uploader'
import EmailButton from '../emailSender/emailButton'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'
import {formatDate} from 'lib/helpers'
import cs from 'classnames'
import * as c from 'state/constants'
import {getTheLanguageCodeByAnyLanguageOnAnyLanguage, getTheLanguageOnAppLangByAnyLanguage,
    getTheGenderOnAppLangByAnyCode} from 'lib/helpers'
import MifidButton from '../DSDocuments/mifidButton'
import Modal from 'react-modal'

const _ = i18n('clientProfile')

const DateValue = ({date, ...rest}) => (
	<span {...rest}>{formatDate(date)}</span>
)

const noteConfirmationModalStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
        whiteSpace: 'pre-wrap',
		position: 'relative',
		top: 'initial',
		bottom: 'initial',
		left: 'initial',
		right: 'initial',
		maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        width: '70%',
        height: 'auto'
    }
}

const printSelect = (item, options) => {
    let itemValue = ""

    // TODO solve to not call this function before the translation values are not loaded by the client dic api.
    if (!options) {
        console.warn('(printSelect) No dictionary loaded and the value not translated for: ', item, " options: ", options)
        return item
    }

    options.map((key, i) => {
        if (Number(item) == Number(key.value)) {
            itemValue = key.label
        }
    })

    return itemValue
}

/**
 * Helper function to select the language from dictionary.
 * @param {*} item
 * @param {*} options
 * @param {*} language
 * @param {*} languageOptions
 */
const clientLanguagePrintSelect = ( item, options, language, languageOptions) => {
    let convertedLanguage;

    if (!options) {
        console.warn('(clientLanguagePrintSelect) No dictionary loaded and the value not translated for: ', item, " options: ", options)
        return item
    }

    // Generate language code from
    if (!language && languageOptions && languageOptions.length > 0) {
        languageOptions.map((index, key) => {
            if (index.label == language) {
                language = index.value
            }
        })
    }

    if (language == 1) {
        language = 'nl';
    }
    else if (language == 2) {
        language = 'fr';
    }
    else if (language == 3) {
        language = 'en';
    } else {
        language = 'nl'
    }

    if (options && options.length > 0) {
        options.map((index, key) => {
            if(index.value == item) {
                convertedLanguage = index.label[language]
            }
        })
    }

    return convertedLanguage
}

/**
 * Generates the client dictionaries to have a same place for each dictionary
 *
 * @param Object clientOptionsDictionary 	The translate list from state.client.clientOptionsDict
 * @param string language 								The language of the application - state.app.lang
 */
const generateClientDicts = (clientOptionsDict, language) => {
    let clientDictionaries = []

    if (!clientOptionsDict) {
        console.warn("Manual error: \"clientOptionsDict\" is not defined for clientProfile module")
        return null
    }

    clientDictionaries['personType'] 			= generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language)
    clientDictionaries['gender']     			= generateOptionsObject(clientOptionsDict.GESLACHT, language)
    clientDictionaries['nationality'] 		    = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language)
    clientDictionaries['language']				= generateOptionsObject(clientOptionsDict.TAAL, language)
    clientDictionaries['title']					= generateOptionsObject(clientOptionsDict.AANSPREKING, language)
    clientDictionaries['licenceCategory']       = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language)
    clientDictionaries['relationType']          = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language)
    clientDictionaries['country']				= generateOptionsObject(clientOptionsDict.LAND, language)
    clientDictionaries['legalForm']             = generateOptionsObject(clientOptionsDict.RECHTSVORM, language)
    clientDictionaries['profession']            = generateOptionsObject(clientOptionsDict.profession, language)
    clientDictionaries['activSector']          = generateOptionsObject(clientOptionsDict.activSector, language)
    clientDictionaries['socialStatus']          = generateOptionsObject(clientOptionsDict.socialStatus, language)
    clientDictionaries['taxStatus']             = generateOptionsObject(clientOptionsDict.taxStatus, language)
    clientDictionaries['ppp']                   = generateOptionsObject(clientOptionsDict.ppp, language)
    clientDictionaries['birthCountry']			= generateOptionsObject(clientOptionsDict.LAND, language)
    clientDictionaries['maritalStatus']			= generateOptionsObject(clientOptionsDict.maritalStatus, language)
    clientDictionaries['globalCountry']         = generateGlobalOptionsObject(clientOptionsDict.LAND)

    clientDictionaries = {
        ...clientOptionsDict,
        ...clientDictionaries
    }

    return clientDictionaries
}

/**
 *
 * @param {*} optionsData
 */
const generateGlobalOptionsObject = (optionsData) => {
    const optionsArray = []

    Object.keys(optionsData).map((key,index) => {
        optionsArray.push({value:key, label: optionsData[key]})
    })

    return optionsArray
}

/**
 * Generate option array based on requested object data
 * @param Object optionsData
 * @param String language
 *
 * @return array
 */
const generateOptionsObject = (optionsData, language) => {
    const optionsArray = []

    Object.keys(optionsData).map((key, index) => {
        optionsArray.push({value: key, label: optionsData[key][language]})
    });

    return optionsArray
}

/**
 * Helper function for Address rendering.
 * @param {*} param0
 */
const AddressValue = ({addressData, clientOptionsDict, clientLanguage}) => {
    const {country, street, number, extension, postalCode, locality} = addressData

    return(
        <div className={styles.addressContainer}>
            <div className={styles.addressColumn}>
                {street} {number}{extension ? '/' + extension : ''} <br/>
                {postalCode} {locality} {country ? clientLanguagePrintSelect(country, clientOptionsDict.globalCountry, clientLanguage, clientOptionsDict.language): country}
            </div>
            {(postalCode || locality) &&
                <div className={styles.addressColumn}>
                    <a href={getGoogleMapsLink(addressData)} target="_blank" className={styles.mapsLink} rel="noopener noreferrer">
                        <img className={cs(styles.emailButtonIcon)} src={getIcon("outline-location_on-24px")}/>
                    </a>
                </div>
            }
        </div>
    )
}

/**
 * @param {object} addressData - contains address info
 */
const getGoogleMapsLink = (addressData) => {
    const {country, street, number, extension, postalCode, locality} = addressData
    let address = [country, street, number, postalCode, locality]
    // https://developers.google.com/maps/documentation/urls/guide
    return "https://www.google.com/maps/search/?api=1&query="+encodeURI(address.join(", "))
}


/**
 * This function helps to use an icon on a safe way
 */
const getIcon = icon => {
    try {
        return require(`resources/images/icn-${icon}.svg`)
    }catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

/**
 * Phone value render helper
 * @param {object} param0
 */
const PhoneValue = ({number}) => <a href={`callto:${number}`}>{number}</a>

/**
 * Help to render bank account.
 * @param {*} param0
 */
const BankAcctValue = ({BIC, IBAN}) => (
	<div>
		<span style={{fontWeight: 'bold'}}>{IBAN}</span><br/>
		<span style={{fontStyle: 'italic'}}>{BIC}</span>
	</div>
)

/**
 * Thins function render the drivers license using category and date.
 * @param {*} param0
 */
const DriversLicenseValue = ({licenceCategory, licenceDate}) => (
	<div>
        {licenceCategory}
        {licenceDate && <span> (<DateValue date={licenceDate}/>)</span>}
	</div>
)

const EasinsureValue = ({eDate}) => (
	<div>
        {eDate && <DateValue date={eDate}/>}
	</div>
)

const multiLineEmail = (data) => (
	data && data.map((line, i) => (
		<p key={i}>
			<a className={(line.default == 'true') ? styles.emailDefault : styles.email} href={`mailto:${line.email}`}>
				{line.email}
			</a>
		</p>
	))
)

const multiLinePhones = (data) => (
	data && data.map((line, i) => (
		<p key={i}>
			<a className={(line.default == 'true') ? styles.phoneDefault : styles.phone} href={`callto:${line.number}`}>
				{line.number}
			</a>
		</p>
	))
)

const EmailValue = ({email}) => (
	<a className={styles.mail} href={`mailto:${email}`}>{email}</a>
)

const ContactValue = ({contactData, clientOptionsDict, appLanguage, navigateToRelatedClient}) => {
    let {contactNumber, contactType, contactName, contactFirstName, contactgender, contactdateOfBirth} = contactData
    let clientGenderOnAppLang = getTheGenderOnAppLangByAnyCode(contactgender, clientOptionsDict, appLanguage)
    // contactgender = genderCodeToTranslateIndex(contactgender)

    return (
        <div>
            <p>
                <span style={{fontWeight: 'bold'}}>{ contactType }</span>
                <span> {contactName} {contactFirstName} (<a onClick={() => navigateToRelatedClient(contactData.contactNumber)} style={{cursor: 'pointer', display: 'inline'}}>{contactNumber}</a>)</span>
            </p>
            {_('dateOfBirth')} {formatDate(contactdateOfBirth, 'eu')}<br/>
            {_('gender')} {clientGenderOnAppLang}<br/>
        </div>
    )
}

const UList = ({children}) => (
	<ul>{children.map((c, i) => <li key={i}>{c}</li>)}</ul>
)

const childMultiLine = (data) => {
    const field = Object.keys(data)[0]
    return (data[field])
}

/**
 * This function convert the gender code to an index from translations (from clientOptionsDict)
 * Return with the index value if exist the code in the white list (M and V). (1 or 2)
 * @param {string} gender
 */
const genderCodeToTranslateIndex = (gender) => {
    if (gender == 'M') {
        gender = 1
    }

    if (gender == 'V' || gender == 'F') {
        gender = 2
    }

    return gender
}

/**
 * This function will render the client profile dome using the process function on the raw data.
 * Use translation on translatable values.
 * @param {object} param0
 */
export const ClientProfileDom = ({
    clientId,
    clientDocuments,
    clientNumber, dateOfBirth, companyRegistrationNumber,
    gender, language, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure,
    address, corrAddr, setSubModule,
    createClientAccess, updateClientAccess, clientOptionsDict, appLanguage,
    createmail, moduleKeyToSet, name, moduleOptions, clientLanguageOnAppLang,
    clientGenderOnAppLang, nationalIdNumber, birthPostalCode,
    birthLocality, birthCountry, amlScore, amlProfile,
    pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel, canCreateMifid, clientNoteObj,
    navigateToRelatedClient, modifyOnlyLegalClient,
    clientTypeValue
}) => {

    const columns = createInfoColumns(clientNumber, dateOfBirth, companyRegistrationNumber, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure,
        address, corrAddr, clientOptionsDict, appLanguage, clientLanguageOnAppLang, clientGenderOnAppLang, nationalIdNumber, birthPostalCode, birthLocality,
        birthCountry, amlScore, amlProfile, pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel,
        navigateToRelatedClient, clientTypeValue)


    return (
        <div className={styles.profileClient}>
            <div className={styles.moduleSection}>
                <div className={styles.moduleSectionHeading}>
                    {_('general')}

                    <div className={styles.editClientProfile}>
                        {((updateClientAccess && !modifyOnlyLegalClient) || (updateClientAccess && modifyOnlyLegalClient
                            && +clientTypeValue === 2
                        )) ?
                            <button key={"btnEditProfile"}
                                className={"btn green " + cs(styles.fullWidth)}
                                onClick={() => setSubModule('edit-profile')}>
                                {_('edit-profile')}
                            </button> : ''}
                        {createmail && <EmailButton moduleKeyToSet={moduleKeyToSet} moduleOptions={moduleOptions} />}
                        {canCreateMifid &&
                            <div className={styles.mifidButtonCorrection}>
                                <MifidButton
                                    moduleKeyToSet={c.DS_MODULE_CLIENT_PROFILE}
                                    clientId={clientId}
                                    callBackOnClose={() => { }}
                                    moduleOptions={moduleOptions}
                                />
                            </div>
                        }
                    </div>
                </div>
                <div className={styles.moduleSectionContent}>
                    {columns ? (
                        <KeyValue array={columns} divider />
                    ) : '…'}
                </div>
                {ClientNoteDom(clientNoteObj)}
            </div>
            <Uploader type="client" documents={clientDocuments} id={clientId} />
        </div>
    )
}

const createInfoColumns = (clientNumber, dateOfBirth, companyRegistrationNumber, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure,
    address, corrAddr, clientOptionsDict, appLanguage, clientLanguageOnAppLang, clientGenderOnAppLang, nationalIdNumber, birthPostalCode, birthLocality,
    birthCountry, amlScore, amlProfile, pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel,
    navigateToRelatedClient, clientTypeValue) => {

    if (clientTypeValue == '2') {
        return [
            [
                { label: `${_('clientNumber')}:`, value: clientNumber },
                { label: `${_('language')}:`, value: clientLanguageOnAppLang },
                { label: `${_('nationality')}:`, value: nationalityLabel },
                {
                    label: `${_('email')}:`,
                    value: multiLineEmail(emails),

                },
                {
                    label: `${_('phoneNumbers')}:`,
                    value: multiLinePhones(phoneNumbers),
                },
                { label: `${_('address')}:`, value: <AddressValue addressData={address} clientOptionsDict={clientOptionsDict} clientLanguage={appLanguage} /> },
                { label: `${_('correspondence')}:`, value: <AddressValue addressData={corrAddr} clientOptionsDict={clientOptionsDict} /> },
                {
                    label: _('easinsureDate') + ":",
                    value: <EasinsureValue eDate={myEasinsure} />,
                },
                { label: `${_('amlScore')}:`, value: amlScore },
                { label: `${_('amlProfile')}:`, value: amlProfile },
            ],
            [
                { label: `${_('companyRegistrationNumber')}:`, value: companyRegistrationNumber },
                { label: `${_('activSector')}:`, value: activSectorLabel },
                { label: `${_('taxStatus')}:`, value: taxStatusLabel },
                {
                    label: `${_('IBAN')}:`,
                    value: <UList>{accountNumbers.map((account, key) => <BankAcctValue {...account} key={key} />)}</UList>,
                },
                {
                    label: `${_('licenceDate')}:`,
                    value: <UList>{licences.map((license, i) => <DriversLicenseValue key={i} {...license} />)}</UList>,
                },
                {
                    label: `${_('familyRelations')}:`,
                    value: <UList>{contacts.map((c, i) => <ContactValue key={i} contactData={c} clientOptionsDict={clientOptionsDict} navigateToRelatedClient={navigateToRelatedClient} appLanguage={appLanguage} />)}</UList>,
                }
            ],
        ]
    } else {
        return [
            [
                { label: `${_('clientNumber')}:`, value: clientNumber },
                { label: `${_('gender')}:`, value: clientGenderOnAppLang },
                { label: `${_('nationalIdNumber')}:`, value: nationalIdNumber },
                { label: `${_('nationality')}:`, value: nationalityLabel },
                { label: `${_('language')}:`, value: clientLanguageOnAppLang },
                {
                    label: `${_('email')}:`,
                    value: multiLineEmail(emails),

                },
                {
                    label: `${_('phoneNumbers')}:`,
                    value: multiLinePhones(phoneNumbers),
                },
                { label: `${_('address')}:`, value: <AddressValue addressData={address} clientOptionsDict={clientOptionsDict} clientLanguage={appLanguage} /> },
                { label: `${_('correspondence')}:`, value: <AddressValue addressData={corrAddr} clientOptionsDict={clientOptionsDict} /> },
                {
                    label: _('easinsureDate') + ":",
                    value: <EasinsureValue eDate={myEasinsure} />,
                },
                { label: `${_('amlScore')}:`, value: amlScore },
                { label: `${_('amlProfile')}:`, value: amlProfile },
            ],
            [
                { label: `${_('dateOfBirth')}:`, value: <DateValue date={dateOfBirth} /> },
                { label: `${_('birthCountry')}:`, value: `${birthPostalCode} ${birthLocality} ${birthCountry}` },
                { label: `${_('maritalStatus')}:`, value: maritalStatusLabel },
                { label: `${_('companyRegistrationNumber')}:`, value: companyRegistrationNumber },
                { label: `${_('profession')}:`, value: professionLabel },
                { label: `${_('activSector')}:`, value: activSectorLabel },
                { label: `${_('socialStatus')}:`, value: socialStatusLabel },
                { label: `${_('taxStatus')}:`, value: taxStatusLabel },
                { label: `${_('ppp')}:`, value: pppLabel },
                {
                    label: `${_('IBAN')}:`,
                    value: <UList>{accountNumbers.map((account, key) => <BankAcctValue {...account} key={key} />)}</UList>,
                },
                {
                    label: `${_('licenceDate')}:`,
                    value: <UList>{licences.map((license, i) => <DriversLicenseValue key={i} {...license} />)}</UList>,
                },
                {
                    label: `${_('familyRelations')}:`,
                    value: <UList>{contacts.map((c, i) => <ContactValue key={i} contactData={c} clientOptionsDict={clientOptionsDict} navigateToRelatedClient={navigateToRelatedClient} appLanguage={appLanguage} />)}</UList>,
                },
            ],
        ]
    }
}

export const ClientNoteDom = (clientNoteObj) => {
    let {clientNote, saveNote, handleNoteChange, toggleNoteEditMode, handleDeleteClientNote}= clientNoteObj

    return (
        <div className={styles.moduleSection}>
            <div className={styles.moduleSectionHeading}>
                {_('notes')}
                {clientNoteObj.noteEditMode?
                    <div className={styles.noteButtons}>
                        <button className={"btn green " + cs(styles.fullWidth)} onClick= {() => saveNote(clientNote)}> {_('save-note')} </button>
                        <button className={styles.gray} onClick= {() => toggleNoteEditMode()}> {_('cancel')} </button>
                    </div>
                    :
                    <div className={styles.noteButtons}>
                        <button className={"btn green " + cs(styles.fullWidth)} onClick= {() => toggleNoteEditMode()}> { clientNote && clientNote._id? _('edit-note') : _('create-note') } </button>
                        {clientNote && clientNote._id && <button className={styles.gray} onClick= {() => handleDeleteClientNote(clientNote._id)}> {_('delete')} </button>}
                    </div>
                }
            </div>
            {clientNoteObj.noteEditMode?
                <div className={styles.noteWrappper}>
                    <textarea className={styles.noteArea} placeholder={_('notes-placeholder')} rows="4" value={clientNote.note} onChange={(e) =>handleNoteChange(e.target.value) }></textarea>
                    {clientNoteObj.noteFieldError &&
                     <span className={styles.noteFieldError}>{_('noteFieldError')}</span>
                    }
                </div>
                :
                <div className={styles.noteWrappper}>
                    <div className={styles.noteView}>{clientNote && clientNote.note || _('notes-placeholder') } </div>
                </div>
            }
        </div>
    )
}

/**
 * Client profile module
 * It is make possible to view edit and create client profile, based on rights from "security.actions".
 */
@connect(state => {
    const clientId = state.app.opened
    const clientAccess = state.app.security.actions
    const appLanguage = state.app.lang
    const EmailTemplateRelations = state.app.security.EmailTemplateRelations
    let canCreateClient, canUpdateClient, canCreateMifid, canCreateOnlyLegalClient, canModifyOnlyLegalClient
    // Generate options for client select lists
    const clientOptionsDict = state.client.clientOptionsDict


    clientAccess.map((item, key) => {
        if (item.actionName == 'createclient') {
            canCreateClient = item.actionAllowed === "true" ? true : false
        }
        if (item.actionName == 'modifyclient') {
            canUpdateClient = item.actionAllowed === "true" ? true: false
        }
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true: false
        }
        if (item.actionName == 'createonlylegalclient') {
            canCreateOnlyLegalClient = item.actionAllowed === "true" ? true: false
        }
        if (item.actionName == 'modifyonlylegalclient') {
            canModifyOnlyLegalClient = item.actionAllowed === "true" ? true: false
        }
    })

    const createmail = clientAccess &&
        clientAccess.filter((item)=>(item.actionName == "createmail" && item.actionAllowed == "true")).length > 0

    return ({
        subModule: state.clients.subModule,
        createClientAccess: canCreateClient,
        updateClientAccess: canUpdateClient,
        createOnlyLegalClient: canCreateOnlyLegalClient,
        modifyOnlyLegalClient: canModifyOnlyLegalClient,
        clientOptionsDict,
        createmail: createmail,
        appLanguage: appLanguage,
        EmailTemplateRelations: EmailTemplateRelations,
        canCreateMifid: canCreateMifid,
    })
})
export default class ClientProfile extends Component {
    static propTypes = {
        clientId: PropTypes.string.isRequired,
        data: React.PropTypes.object,
        clientOptionsDict: React.PropTypes.object
    }

    /**
     * Initialise the module state in constructor.
     * The "clientOptionsDict" state value used for translate few value to the selected app language.
     *   The translation dictionary loaded asynchronously and set up in state, what trigger automatically
     *   the rendering again.
     * @param {object} props
     */
    constructor(props) {
        super(props)

        let {clientOptionsDict} = props

        this.state = {clientOptionsDict, firstBrokerNumberFromOfficeBrokers: '', clientNote: null, noteEditMode: false, originalNote: null, noteFieldError: false, deleteNoteId: ''}
    }

    /**
     * Before mounting the module we have to verify if we have already loaded the client option dictionary.
     */
    componentWillMount() {
        const {dispatch, appLanguage, clientOptionsDict, clientId} = this.props
        const {clientNote} = this.state

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
            .then((dictionary) => {
                this.setClientOptionsDict(dictionary)
            })
        } else {
            if (!this.state.clientOptionsDict) {
                this.setClientOptionsDict(clientOptionsDict)
            }
        }

        // get clinet note from backoffice if there is none it creates a temp one
        if(!clientNote && clientId) {
            dispatch(getClientNote({clientId})).then(res => {
                if(res && res._id){
                    this.setState({clientNote: res})
                }else{
                    const newClientNote = {}
                    newClientNote.note = ''
                    newClientNote.clientId = clientId
                    this.setState({clientNote: newClientNote})
                }
            })
        }

        // get office data to get the broker list. Use the first one brokerNumber for the email sender
        dispatch(fetchOfficeData()).then((result)=>{
            let brNr = nesProp.get(result, "officeInfo.brokers.0.brokerNumber")
            this.setState({firstBrokerNumberFromOfficeBrokers: brNr})
        })
    }

    /**
     * Set client options dict in to the state
     */
    setClientOptionsDict(dictionary) {
        const {appLanguage} = this.props
        let clientOptionsDict = generateClientDicts(dictionary, appLanguage)

        this.setState({clientOptionsDict}, () => {
            this.forceUpdate()
        })
    }

    setSubModule(subModuleName) {
        const {dispatch} = this.props
        dispatch(setOpenedSubmenu())
        dispatch(setClientSubModule(subModuleName))
    }

    saveNote (clientNote) {
        const {dispatch} = this.props
        dispatch(saveClinetNote(clientNote)).then(res => {
            if(res && res._id){
                dispatch(setNotification(_('clientNoteSave'), 'success'))
                this.setState({clientNote: {...clientNote, _id : res._id}, noteEditMode: false, originalNote: null, noteFieldError: false})
            }
        })
    }

    handleNoteChange(val) {
        const { clientNote } = this.state
        clientNote.note = val
        this.setState({clientNote: clientNote})
    }

    toggleNoteEditMode() {
        const { clientNote, noteEditMode, originalNote } = this.state
        if(!noteEditMode){
            this.setState({noteEditMode: !noteEditMode, originalNote: {...clientNote}})
        }else{
            this.setState({noteEditMode: !noteEditMode, clientNote: {...originalNote}, originalNote: null})
        }
    }

    handleDeleteClientNote (id) {
        const {dispatch, clientId} = this.props
        const data = {clientNoteId: id}
        dispatch(deleteClientNote(data)).then(res => {
            if(res && res.ok)
            dispatch(setNotification(_('clientNoteDelete'), 'success'))
            this.setState({clientNote: {note: '', clientId}, isOpenAreYouSure: false, deleteNoteId: ''})
            })
    }

    openModal(e) {
        e.preventDefault()
        const { dispatch, initializeProfileForm, toggleModalClientProfileForm, modalState } = this.props

        dispatch(toggleModalClientProfileForm(!modalState))
        dispatch(initializeProfileForm({}, null, 'create'))
    }

    /**
     * This function return with values for email sender, collected from this module
     * depending on the current data structure.
     */
    collectVariableValues() {
        let emails = nesProp.get(this.props, "data.detail.emails")
        let clientName = nesProp.get(this.props, "data.main.name")
        // process email list to be digestible for email sender
        emails = emails.map((item) => ({
            referenceId: nesProp.get(this.props, "clientId"),
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        }))

        emails = emails.sort((item, item2)=>{
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(this.props, "data.detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, this.state.clientOptionsDict)

        return {
            clientNumber: nesProp.get(this.props, "data.main.clientNumber"),
            clientName: clientName,
            clientLanguage,
            clientEmails: emails,

            // v6 style
            clientDocuments: nesProp.get(this.props, "data.clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: nesProp.get(this.props, "clientId"),

            clientId: nesProp.get(this.props, "clientId"),
            contractId: false,
            claimId: false,

            brokerNumber: '',//nesProp.get(this.state, "firstBrokerNumberFromOfficeBrokers"),
            clientData: nesProp.get(this.props, "data.main"),
        }
    }

    resolveMissingLabels(appLanguage, clientOptionsDict2, clientData) {
        const labels = {}
        const clientOptionsDict = this.props.clientOptionsDict
        Object.keys(clientData).forEach(key => {
            const value = clientData[key]
            if(clientOptionsDict && clientOptionsDict[key] && clientOptionsDict[key][value] && clientOptionsDict[key][value][appLanguage])
            {
                labels[ key + `Label`] = clientOptionsDict[key][value][appLanguage]
            }else if(key === 'nationality' && clientOptionsDict['NATIONALITEIT'] && clientOptionsDict['NATIONALITEIT'][value] && clientOptionsDict['NATIONALITEIT'][value][appLanguage]){
                labels[ key + `Label`] = clientOptionsDict['NATIONALITEIT'][value][appLanguage]
            }else if(key === 'language' && clientOptionsDict['TAAL'] && clientOptionsDict['TAAL'][value] && clientOptionsDict['TAAL'][value][appLanguage]){
                labels[ key + `Label`] = clientOptionsDict['TAAL'][value][appLanguage]
            }else{
                labels[ key + `Label`] = value
            }
        })
        return labels
    }

    getTypeValueFromLabel(clientTypeLabel) {
        const { clientOptionsDict } = this.state
        const language = this.props.appLanguage
        const generatedClientDicts = generateClientDicts(clientOptionsDict, language)
        let typeValue
        if (clientTypeLabel != undefined) {
            generatedClientDicts.personType.map((item) => {
                if (clientTypeLabel == item.label) {
                    typeValue = item.value
                }
            })
        }
        
        if(!typeValue && +clientTypeLabel === NaN) {
            console.error('Failed to get value from label: ', clientTypeLabel);
        }
        return typeValue ? typeValue : clientTypeLabel
    }

    navigateToRelatedClient (clientNumber) {
        const {dispatch} = this.props
        return dispatch(fetchRelationClient({clientNumber})).then(res=>{
            dispatch(setOpened(res[0].clientId))
            dispatch(setClientSubModule('profile'))
        })
	}


	render() {
        const {clientOptionsDict, clientNote, noteEditMode, noteFieldError, isOpenAreYouSure, deleteNoteId} = this.state
        if (!clientOptionsDict) {
            return (<span>...</span>)
        }

        const setSubModule = (item) => {
            this.setSubModule(item)
        }

        const openModal = (e) => {
            this.openModal(e)
        }

        const clientNoteObj = {}
        clientNoteObj.saveNote = (e) => {
            if (e.note) {
                this.saveNote(e)
            } else {
                this.setState({noteFieldError: true})
            }
        }
        clientNoteObj.handleNoteChange = (val) => {
            this.handleNoteChange(val)
        }
        clientNoteObj.toggleNoteEditMode = () => {
            this.toggleNoteEditMode()
        }
        clientNoteObj.handleDeleteClientNote = (id) => {
            this.setState({deleteNoteId: id, isOpenAreYouSure: true})
        }
        clientNoteObj.noteEditMode = noteEditMode
        clientNoteObj.clientNote = clientNote
        clientNoteObj.noteFieldError = noteFieldError

        const {clientId, data, createClientAccess, updateClientAccess, appLanguage,
            createmail, moduleKey, canCreateMifid, modifyOnlyLegalClient} = this.props

        const detail = data && data.detail || {}
        const main = data && data.main || {}
        const clientDocuments = data && data.clientDocuments || []

        const {clientNumber, dateOfBirth, companyRegistrationNumber, name} = main
        const {gender, language, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure, nationality,
             birthPostalCode, nationalIdNumber, birthLocality, birthCountry, maritalStatus, amlScore, amlProfile,
             profession, activSector, socialStatus, taxStatus, ppp} = detail

        const labels = this.resolveMissingLabels(appLanguage, clientOptionsDict, {ppp, nationality, maritalStatus, profession, activSector, socialStatus, taxStatus, language})
        const { pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel, languageLabel } = labels
        contacts.map( contact => {
            if(clientOptionsDict && clientOptionsDict['HOEDANIGHEID'] && clientOptionsDict['HOEDANIGHEID'][contact.contactType] && clientOptionsDict['HOEDANIGHEID'][contact.contactType][appLanguage]){
                contact.contactType = clientOptionsDict['HOEDANIGHEID'][contact.contactType][appLanguage]
            }
        })

        const address = data && main.mainAddress
        const corrAddr = data && detail.correspondanceAddress
        const moduleKeyToSet = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsProfile.value") || false
        const moduleOptions = this.collectVariableValues()

            // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguageOnAppLang = getTheLanguageOnAppLangByAnyLanguage(languageLabel, this.state.clientOptionsDict, this.props.appLanguage)
        let clientGenderOnAppLang = getTheGenderOnAppLangByAnyCode(gender, this.state.clientOptionsDict, this.props.appLanguage)

        const clientTypeValue = this.getTypeValueFromLabel(data.main.clientType)

        return (
            <div>
                <ClientProfileDom
                    {...{
                        clientId,
                        clientDocuments,
                        clientNumber, dateOfBirth, companyRegistrationNumber,
                        gender, languageLabel, emails, licences, phoneNumbers, accountNumbers, contacts,
                        address, corrAddr, myEasinsure,
                        createClientAccess, updateClientAccess,openModal, clientOptionsDict, appLanguage,
                        createmail, moduleKeyToSet, name, moduleOptions, clientLanguageOnAppLang,
                        clientGenderOnAppLang, nationalIdNumber, birthPostalCode, birthLocality,
                        birthCountry, maritalStatus, amlScore, amlProfile,
                        pppLabel, nationalityLabel, maritalStatusLabel, professionLabel, activSectorLabel, socialStatusLabel, taxStatusLabel, canCreateMifid, clientNote,
                        modifyOnlyLegalClient,
                        clientTypeValue
                    }}
                    setSubModule={setSubModule}
                    clientNoteObj={clientNoteObj}
                    navigateToRelatedClient={(clientNumber) => this.navigateToRelatedClient(clientNumber)}
                />


                <Modal
                    isOpen={isOpenAreYouSure}
                    style={noteConfirmationModalStyles}
                    contentLabel={""}
                >
                    <div className={styles.confirmationModalContent}>
                        <span className={styles.title}>{_('deleteNoteConfirmationTitle')}</span>
                            <span className={styles.message}>
                                {_('deleteNoteConfirmationMessage')}
                            </span>
                            <div className={styles.documentsModalButtons}>
                                <div
                                    onClick={()=>{
                                        this.setState({isOpenAreYouSure: false})
                                    }}
                                    className={styles.cancel}
                                >
                                    {_("cancel")}
                                </div>
                                <div
                                    onClick={()=>{
                                        this.handleDeleteClientNote(deleteNoteId)

                                    }}
                                    className={styles.greenButton + " enabled"}
                                >
                                    {_("ok")}
                                </div>
                            </div>
                    </div>
                </Modal>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientProfile.jsx